import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CloseInvoiceConfirmationComponent } from './close-invoice-confirmation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RippleModule } from 'primeng/ripple';
import { PipeModule } from '../../pipe.module';

@NgModule({
  declarations: [CloseInvoiceConfirmationComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextareaModule,
    ButtonModule,
    RippleModule,
    PipeModule,
  ],
  exports: [CloseInvoiceConfirmationComponent],
})
export class CloseInvoiceConfirmationModule {}

